<div class="flex flex-column w-full h-full gap-3">

  <ng-container *ngIf="!tableOrImg">
      <div class="imagenPag">
          <img id="imagen" src="../../../../../../assets/img/main/file-searching.svg" alt="" />
          <p class="descriptionPage">
              Ud. no ha generado ningún usuario
          </p>
      </div>
  </ng-container>

  <ng-container *ngIf="tableOrImg">
      <app-users-table></app-users-table>
  </ng-container>
</div>
